import React from 'react';
import { Link } from "react-router-dom"
import '../../assets/css/news.css';
import { toDateTimeStringEnglish, toDateTimeStringVietnamese, toSlug } from '../../utils/utils'
import { useIntl } from 'react-intl'; // ✅ Thêm useIntl

import { IMAGE_BASE_URL } from 'utils/constants';

export default function ContentNewsItem({ infoItem }) {
                const intl = useIntl();
    
                const pathSplit = window.location.pathname.split('/')
                const lang = pathSplit[1]
    const isVietnamese = lang === 'vi'
    const finalImageBaseUrl = isVietnamese ? 'https://demolqdtu.click' : IMAGE_BASE_URL;

    return (
        <div>
            <div className="post-wrapper unicamp-box">
                <div className="post-feature post-thumbnail unicamp-image">
                    <Link to={`${isVietnamese ? '/vi' : ''}/listnews/detail/${infoItem.id}-${toSlug(infoItem.title)}`}>
                        <img src={`${finalImageBaseUrl}/${infoItem.image_URL}`} alt={infoItem.title}>
                        </img>
                        <div className="tm-button-wrapper post-read-more">
                            <div className="tm-button style-flat tm-button-xs tm-button-full-wide icon-right">
                                <div className="button-content-wrapper mt-2 ml-0">
                                    <span className="">
                                    {intl.formatMessage({ id: 'Read More' })} <i className="nc-icon nc-minimal-right" />
                                    </span>
                                    <span className="button-icon">

                                    </span>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="post-caption">
                    <div className="post-categories">
                        <Link to={`${isVietnamese ? '/vi' : ''}/news/${infoItem.category.name.toLowerCase()}`}>
                            {intl.formatMessage({ id: infoItem.category.name})}
                        </Link>
                    </div>
                    <h3 className="post-title post-title-2-rows">
                        <Link to={`${isVietnamese ? '/vi' : ''}/listnews/detail/${infoItem.id}-${toSlug(infoItem.title)}`} className="news_title_slide">
                            {infoItem.title}
                        </Link>
                    </h3>
                    <div className="post-meta">
                        <div className="inne">
                            <div className="post-meta-author">
                                <a href="#" onClick={(e) => e.preventDefault()}>
                                    <span className="meta-value">
                                        {infoItem.author}
                                    </span>
                                </a>
                            </div>
                            <div className="post-date">
                                <p className="meta-value">
                                {isVietnamese ? toDateTimeStringVietnamese(infoItem.date_created) : toDateTimeStringEnglish(infoItem.date_created)}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
